/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Helmet } from "react-helmet-async";
import React, { useEffect, useState } from "react";

import {
  Card,
  Stack,
  Button,
  Popover,
  MenuItem,
  Container,
  Typography,
  Checkbox,
  Grid,
  Divider,
  useTheme,
  Box,
  Link,
  Alert,
} from "@mui/material";
import Iconify from "../../../../components/iconify";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import "./manage-event.css";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import DvrTwoToneIcon from "@mui/icons-material/DvrTwoTone";
import { StepIconProps } from "@mui/material/StepIcon";
import { GET, POST } from "../../../../config/https";
import APIS from "../../../../config/api";
import FullScreenLoader from "../../../../components/full-screen-loader";
import toast from "react-hot-toast";
import EditLocationAltTwoToneIcon from "@mui/icons-material/EditLocationAltTwoTone";
import ConfirmationNumberTwoToneIcon from "@mui/icons-material/ConfirmationNumberTwoTone";
import QuizTwoToneIcon from "@mui/icons-material/QuizTwoTone";
import PublishedWithChangesTwoToneIcon from "@mui/icons-material/PublishedWithChangesTwoTone";
import useMediaQuery from "@mui/material/useMediaQuery";
import Color from "../../../../theme/color";
import { useLocation } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar/DateCalendar";
import { MultiSectionDigitalClock } from "@mui/x-date-pickers/MultiSectionDigitalClock/MultiSectionDigitalClock";
import moment from "moment";
import EventDetails from "./event-detail";
import { usePersistentState } from "../../../../contexts/global-context";
import EventVenueSchedule from "./event-venue-schedule";
import EventTicketConfig from "./event-ticket-config";
import EventFaq from "./event-faq";
import EventSummery from "./event-summery";
import { useLayoutEffect } from "react";
import { GetLocalStorage } from "../../../../utils/local-storage";
import { marginBottomSize } from "../../../../utils/constant";
import dayjs from "dayjs";
import SeparateDateTime from "../../../../utils/sparate-time-date";
type CurrentComponent = "date" | "time" | "dateRange";

const ColorLibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: `linear-gradient( 95deg, #0280B9 0%, #0294D6 50%, ${Color.secondary} 100%)`,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: `linear-gradient( 95deg,#0280B9 0%, #0294D6 50%, ${Color.secondary} 100%)`,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
  [`@media (min-width: 900px)`]: {
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 22,
    },
  },
}));

export default function AddEvent() {
  const [state, dispatch]: any = usePersistentState();
  const location: any = useLocation();
  const navigate = useNavigate();
  const [dateComponent, setCurrentComponent] =
    useState<CurrentComponent>("date");
  const [open, setOpen] = useState(null);
  const [isAgree, setIsAgree] = useState(false);
  const [wizardKey, setWizardKey] = useState(0);
  const [addEventType, setAddEventType] = useState("");
  const [schedulePublishDate, setSchedulePublishDate] = useState(new Date());
  const [schedulePublishTime, setSchedulePublishTime] = useState(new Date());
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [activeSteps, setActiveSteps] = useState(1);
  const [loader, setLoader] = useState(false);
  const [eventId, setEventId] = useState(null);
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md" || "sm"));
  const isPublishSchedulePopOpen = Boolean(anchorEl);
  const clearGlobalContext = () => {
    dispatch({ type: "CLEAR_STATE" });
    dispatch({ FilledSteps: [] });
    dispatch({ WizardKey: 0 });
    localStorage.removeItem("eventDetails");
    localStorage.removeItem("eventVenue");
    localStorage.removeItem("eventSchedule");
    localStorage.removeItem("eventTicketConfig");
    localStorage.removeItem("eventFaq");
  };
  useEffect(() => {
    const pathArray = location.pathname.split("/");
    const eventIdIndex = pathArray.findIndex(
      (segment: any) => segment === "event"
    );

    if (eventIdIndex !== -1 && pathArray[eventIdIndex + 1]) {
      const extractedId = pathArray[eventIdIndex + 1];
      const updatedId =
        extractedId.toLowerCase() === "add" ? null : extractedId;
      setEventId(updatedId);
    } else {
      setEventId(null);
    }
  }, [location.pathname, eventId]);

  useLayoutEffect(() => {
    return () => {
      clearGlobalContext();
      setEventId(null);
    };
  }, []);

  useEffect(() => {
    if (eventId) {
      setEventId(eventId);
    }
  }, [eventId]);

  useEffect(() => {
    if (eventId) {
      dispatch({ IsGetByIdEvent: true });
      getByIdEventDetail();
    }
  }, [eventId]);

  useEffect(() => {
    const fetchLocalStorageData: any = async () => {
      try {
        let event: any = await localStorage.getItem("eventDetails");
        let eventDetail = JSON.parse(event);

        if (eventDetail && eventDetail.publicSchedule) {
          const storedDateTime = moment(eventDetail.publicSchedule);
          const datePart = storedDateTime.format("YYYY-MM-DD");
          const timePart = storedDateTime.format("HH:mm:ss");

          setSchedulePublishDate(new Date(datePart));
          setSchedulePublishTime(new Date(`1970-01-01T${timePart}`));
        }
      } catch (error) {
        console.error("Error fetching data from local storage:", error);
      }
    };

    fetchLocalStorageData();
  }, [eventId]);

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const wizardNextOnClick = async () => {
    dispatch({ AddEventType: "" });
    if (state.WizardKey === 0) {
      dispatch({ AddEventType: "AddEventDetail" });
      dispatch({ toggleState: (prevState: any) => !prevState });
    }
    if (state.WizardKey === 1) {
      dispatch({ AddEventType: "AddEventVenueSchedule" });
      dispatch({ toggleState: (prevState: any) => !prevState });
    }
    if (state.WizardKey === 2) {
      dispatch({ AddEventType: "AddTicketConfig" });
      dispatch({ toggleState: (prevState: any) => !prevState });
    }
    if (state.WizardKey === 3) {
      dispatch({ AddEventType: "AddEventFaq" });
      dispatch({ toggleState: (prevState: any) => !prevState });
    }
    setLoader(false);
  };
  const handleStepClick = (stepIndex: any) => () => {
    if (stepIndex < activeSteps) {
      setActiveSteps(stepIndex);
    }
  };
  const handleSetIsAgree = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsAgree(event.target.checked);
  };

  const wizardRedirectOnClick = (step: any) => {
    if (state?.FilledSteps?.includes(step)) {
      dispatch({ WizardKey: step });
      setWizardKey(wizardKey + 1);
    }
  };

  const wizardPreviousOnClick = () => {
    if (state.WizardKey === 0) return;
    dispatch({ WizardKey: state.WizardKey - 1 });
    setWizardKey(wizardKey + 1);
  };

  const ColorLibStepIconRoot = styled("div")<{
    ownerState: { completed?: boolean; active?: boolean };
  }>(({ theme, ownerState }) => ({
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
    zIndex: 1,
    color: "#fff",
    width: isMatch ? 27 : 50,
    height: isMatch ? 27 : 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    ...(ownerState.active && {
      backgroundImage: `linear-gradient( 136deg, ${Color.secondary} 0%, #0294D6 50%, #0280B9 100%)`,
      boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
    }),
    ...(ownerState.completed && {
      backgroundImage: `linear-gradient( 136deg, ${Color.secondary} 0%, #0294D6 50%, #0280B9 100%)`,
    }),
  }));

  function ColorLibStepIcon(props: StepIconProps) {
    const { active, completed, className } = props;

    const isMobile = useMediaQuery("(max-width: 800px)");

    const iconSize = isMobile ? "1rem" : "1.5rem";

    const icons: { [index: string]: React.ReactElement } = {
      1: <DvrTwoToneIcon style={{ fontSize: iconSize }} />,
      2: <EditLocationAltTwoToneIcon style={{ fontSize: iconSize }} />,
      3: <ConfirmationNumberTwoToneIcon style={{ fontSize: iconSize }} />,
      4: <QuizTwoToneIcon style={{ fontSize: iconSize }} />,
      5: <PublishedWithChangesTwoToneIcon style={{ fontSize: iconSize }} />,
    };

    return (
      <ColorLibStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        {icons[String(props.icon)]}
      </ColorLibStepIconRoot>
    );
  }

  const steps = [
    "Event Detail",
    "Venue & Schedule",
    "Ticket Config",
    "FAQ",
    "Publish Event",
  ];

  const handlePublishOnClick = () => {
    if (isAgree) {
      publishEvent();
    } else {
      toast.error("Please check I agree to the privacy and policy");
    }
  };
  let eventDetail = GetLocalStorage("eventDetails");
  const handleDateChange = async (e: any, key: string) => {
    if (key === "time") {
      let selectedDate: any = new Date(e);
      setSchedulePublishTime(selectedDate);
    }
    if (key === "date") {
      let selectedDate: any = new Date(e);
      let date: any = null;
      var temp = await SeparateDateTime(selectedDate);
      date = temp?.date;
      setSchedulePublishDate(selectedDate);
    }
  };

  const handleClickOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const publishEvent = async () => {
    try {
      setLoader(true);
      let event: any = await localStorage.getItem("eventDetails");
      let EventId = JSON.parse(event);

      if (!EventId) return;
      let param = {
        eventId: EventId?.id,
        isPublish: true,
      };
      await POST(APIS.PUBLISH_EVENT, param)
        .then((res: any) => {
          if (res?.isSuccess) {
            toast.success("Event has been published successfully", {
              style: {
                zIndex: 150000,
              },
            });
            dispatch({ type: "CLEAR_STATE" });
            dispatch({ FilledSteps: [] });
            dispatch({ WizardKey: 0 });
            let keysToRemove = [
              "eventDetails",
              "eventVenue",
              "eventSchedule",
              "eventTicketConfig",
              "eventFaq",
            ];
            keysToRemove.map((x) => {
              localStorage.removeItem(x);
            });

            navigate("/dashboard/events");
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log("error");
    }
  };
  const handleCloseDatePopover = async () => {
    setAnchorEl(null);
  };

  const eventSchedulePublicDate = async () => {
    handleCloseDatePopover();
    if (!isAgree) {
      return toast.error("Please check I agree to the privacy and policy");
    }
    dispatch({ FullScreenLoader: true });
    try {
      let event: any = await localStorage.getItem("eventDetails");
      let eventDetail = JSON.parse(event);
      if (!eventDetail) return;
      const datePart = moment(schedulePublishDate).format("YYYY-MM-DD");
      const timePart = moment(schedulePublishTime).format("HH:mm:ss");
      const combinedDateTime: any = moment(`${datePart} ${timePart}`);
      let param = {
        eventId: eventDetail?.id,
        publicSchedule: combinedDateTime?._i,
      };
      await POST(APIS.EVENT_PUBLISH_SCHEDULE, param)
        .then((res: any) => {
          if (res?.isSuccess) {
            toast.success("Event has been scheduled successfully");
            dispatch({ type: "CLEAR_STATE" });
            dispatch({ FilledSteps: [] });
            dispatch({ WizardKey: 0 });
            let keysToRemove = [
              "eventDetails",
              "eventVenue",
              "eventSchedule",
              "eventTicketConfig",
              "eventFaq",
            ];
            keysToRemove.map((x) => {
              localStorage.removeItem(x);
            });

            navigate("/dashboard/events");
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    } catch {}
    dispatch({ FullScreenLoader: false });
  };

  const getByIdEventDetail = async () => {
    try {
      if (!eventId) return;
      console.log("eventId", eventId);
      await GET(`${APIS.GET_BY_ID_EVENT}?id=${eventId}`)
        .then((res: any) => {
          console.log("res", res);
          if (res?.isSuccess) {
            if (res?.result) {
              localStorage.setItem("eventDetails", JSON.stringify(res?.result));
              dispatch({ AddEvent: res?.result });
            }
            if (res?.result?.eventVenue) {
              localStorage.setItem(
                "eventVenue",
                JSON.stringify(res?.result?.eventVenue)
              );

              let newData = [0];
              dispatch({ FilledSteps: newData });
            } else {
              dispatch({ WizardKey: 1 });
              return;
            }
            if (res?.result?.eventSchedules.length !== 0) {
              localStorage.setItem(
                "eventSchedule",
                JSON.stringify(res?.result?.eventSchedules)
              );
              let newData = [0, 1];
              dispatch({ FilledSteps: newData });
            } else {
              dispatch({ WizardKey: 1 });
              return;
            }
            if (res?.result?.eventTicketConfigs.length !== 0) {
              localStorage.setItem(
                "eventTicketConfig",
                JSON.stringify(res?.result?.eventTicketConfigs)
              );
              let newData = [0, 1, 2];
              dispatch({ FilledSteps: newData });
            } else {
              dispatch({ WizardKey: 2 });
              return;
            }
            if (res?.result?.eventFaqs.length !== 0) {
              localStorage.setItem(
                "eventFaq",
                JSON.stringify(res?.result?.eventFaqs)
              );
              let newData = [0, 1, 2, 3, 4];
              dispatch({ FilledSteps: newData });
              dispatch({ WizardKey: 4 });
            } else {
              dispatch({ WizardKey: 3 });
              return;
            }
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    } catch {}
  };

  const isMobile = useMediaQuery("(max-width: 800px)");

  return (
    <>
      <Helmet>
        <title> Event | EventPrix </title>
      </Helmet>

      <Container maxWidth={"xl"} style={{ marginBottom: marginBottomSize }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          {eventId === null ? (
            <Typography variant="h4" gutterBottom>
              Add Event
            </Typography>
          ) : (
            <Typography variant="h4" gutterBottom>
              Edit Event
            </Typography>
          )}
          <Button
            variant="contained"
            style={{ backgroundColor: Color.primary }}
            startIcon={<Iconify icon="ep:back" />}
            onClick={() => {
              navigate("/dashboard/events");
            }}
          >
            Back
          </Button>
        </Stack>

        <Card sx={{ padding: "40px 15px 40px 15px" }}>
          <Stack sx={{ width: "100%", padding: 0, margin: 0 }} spacing={2}>
            <Stepper
              alternativeLabel
              activeStep={state.WizardKey}
              connector={<ColorLibConnector />}
              sx={{ overflow: "auto", padding: 0, margin: 0 }}
            >
              {steps.map((label, index) => (
                <Step
                  key={index}
                  onClick={handleStepClick(index)}
                  sx={{
                    width: "auto",
                    paddingRight: 0,
                    paddingLeft: 0,
                    marginRight: 0,
                    marginLeft: 0,
                  }}
                >
                  <StepLabel
                    StepIconComponent={ColorLibStepIcon}
                    onClick={() => wizardRedirectOnClick(index)}
                    sx={{
                      paddingRight: 0,
                      paddingLeft: 0,
                      marginRight: 0,
                      marginLeft: 0,
                      width: "auto",
                      display: "flex",
                      justifyItems: "flex-start",
                      cursor: "pointer",
                    }}
                  >
                    <Typography sx={{ fontSize: isMatch ? "9px" : "15px" }}>
                      {label}
                    </Typography>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Stack>
          <Divider sx={{ marginTop: 5 }} />
          <Box sx={{ width: "100%" }}>
            <Grid container columns={{ xs: 12, sm: 12, md: 12 }}>
              {state.WizardKey === 0 ? (
                <EventDetails
                  wizardKey={wizardKey}
                  addEventType={addEventType}
                />
              ) : null}
              {state.WizardKey === 1 ? (
                <div style={{ width: "100%" }}>
                  <EventVenueSchedule />{" "}
                </div>
              ) : null}
              {state.WizardKey === 2 ? (
                <EventTicketConfig wizardKey={2} />
              ) : null}
              {state.WizardKey === 3 ? (
                <div style={{ width: "100%", marginTop: 35 }}>
                  <EventFaq />
                </div>
              ) : null}
              {state.WizardKey === 4 ? (
                <>
                  <EventSummery />
                  <Grid item xs={12} sm={12} md={12}>
                    <div
                      style={{
                        ...Styles.labelTextCheckBox,
                      }}
                    >
                      <Checkbox
                        aria-label="Agree"
                        onChange={(event) => handleSetIsAgree(event)}
                        value={isAgree}
                      />
                      <Typography sx={{ width: "80%", fontWeight: "600" }}>
                        I agree to the{" "}
                        <Link
                          href="/terms-and-conditions"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          terms
                        </Link>{" "}
                        and acknowledge the{" "}
                        <Link
                          href="/privacy-and-policy"
                          // color={Color.primary}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          privacy policy.
                        </Link>
                      </Typography>
                    </div>
                  </Grid>
                </>
              ) : null}
            </Grid>
          </Box>
          <Divider sx={{ marginTop: 10, marginBottom: 5 }} />
          {state.WizardKey === 4 &&
            eventDetail?.publicSchedule !== null &&
            eventDetail?.publish !== true && (
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Alert severity="info">
                  On{" "}
                  {moment(eventDetail?.publicSchedule).format(
                    "MMM DD, YYYY  h:mm A"
                  )}
                  , the event is scheduled to be published.
                </Alert>
              </div>
            )}

          {isMobile ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 40,
              }}
            >
              <Button
                variant="contained"
                style={{
                  backgroundColor: Color.primary,
                  marginBottom: 10,
                }}
                startIcon={<Iconify icon="ep:back" />}
                onClick={() => {
                  wizardPreviousOnClick();
                }}
              >
                {state.WizardKey === 0 ? "Back" : "Previous"}
              </Button>
              {state?.AddEvent?.publish === true ? (
                <div>
                  {state.WizardKey === 4 && (
                    <Button
                      style={{ backgroundColor: Color.primary }}
                      variant="contained"
                      onClick={() => {
                        handlePublishOnClick();
                      }}
                      sx={{ marginRight: 1 }}
                    >
                      {"Publish"}
                    </Button>
                  )}
                  {state.WizardKey === 4 ? null : (
                    <Button
                      style={{ backgroundColor: Color.primary }}
                      variant="contained"
                      endIcon={
                        state.WizardKey === 5 ? null : (
                          <Iconify icon="grommet-icons:link-next" />
                        )
                      }
                      onClick={(e) => {
                        if (state.WizardKey === 4) {
                          handleClickOpen(e);
                        } else {
                          wizardNextOnClick();
                        }
                      }}
                    >
                      {state.WizardKey === 4 ? "" : "Save & Next"}
                    </Button>
                  )}
                </div>
              ) : (
                <div>
                  {state.WizardKey === 4 && (
                    <Button
                      style={{ backgroundColor: Color.primary }}
                      variant="contained"
                      onClick={() => {
                        handlePublishOnClick();
                      }}
                      sx={{ marginRight: 1 }}
                    >
                      {"Publish"}
                    </Button>
                  )}
                  <Button
                    style={{ backgroundColor: Color.primary }}
                    variant="contained"
                    endIcon={
                      state.WizardKey === 5 ? null : (
                        <Iconify icon="grommet-icons:link-next" />
                      )
                    }
                    onClick={(e) => {
                      if (state.WizardKey === 4) {
                        handleClickOpen(e);
                      } else {
                        wizardNextOnClick();
                      }
                    }}
                  >
                    {state.WizardKey === 4 ? "Schedule Publish" : "Save & Next"}
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                marginTop: 40,
              }}
            >
              {state.WizardKey !== 0 ? (
                <Button
                  variant="contained"
                  style={{ backgroundColor: Color.primary }}
                  startIcon={<Iconify icon="ep:back" />}
                  onClick={() => {
                    wizardPreviousOnClick();
                  }}
                >
                  {state.WizardKey === 0 ? "Back" : "Previous"}
                </Button>
              ) : (
                <Button
                  variant="contained"
                  style={{ visibility: "hidden" }}
                  startIcon={<Iconify icon="ep:back" />}
                  onClick={() => {
                    wizardPreviousOnClick();
                  }}
                >
                  {state.WizardKey === 0 ? "Back" : "Previous"}
                </Button>
              )}
              {state?.AddEvent?.publish === true ? (
                <div>
                  {state.WizardKey === 4 && (
                    <Button
                      style={{ backgroundColor: Color.primary }}
                      variant="contained"
                      onClick={() => {
                        handlePublishOnClick();
                      }}
                      sx={{ marginRight: 1 }}
                    >
                      {"Publish"}
                    </Button>
                  )}
                  {state.WizardKey === 4 ? null : (
                    <Button
                      style={{ backgroundColor: Color.primary }}
                      variant="contained"
                      endIcon={
                        state.WizardKey === 5 ? null : (
                          <Iconify icon="grommet-icons:link-next" />
                        )
                      }
                      onClick={(e) => {
                        if (state.WizardKey === 4) {
                          handleClickOpen(e);
                        } else {
                          wizardNextOnClick();
                        }
                      }}
                    >
                      {state.WizardKey === 4 ? "" : "Publish & Next"}
                    </Button>
                  )}
                </div>
              ) : (
                <div>
                  {state.WizardKey === 4 && (
                    <Button
                      style={{ backgroundColor: Color.primary }}
                      variant="contained"
                      onClick={() => {
                        handlePublishOnClick();
                      }}
                      sx={{ marginRight: 1 }}
                    >
                      {"Publish"}
                    </Button>
                  )}
                  <Button
                    style={{ backgroundColor: Color.primary }}
                    variant="contained"
                    endIcon={
                      state.WizardKey === 5 ? null : (
                        <Iconify icon="grommet-icons:link-next" />
                      )
                    }
                    onClick={(e) => {
                      if (state.WizardKey === 4) {
                        handleClickOpen(e);
                      } else {
                        wizardNextOnClick();
                      }
                    }}
                  >
                    {state.WizardKey === 4 ? "Schedule Publish" : "Save & Next"}
                  </Button>
                </div>
              )}
            </div>
          )}
        </Card>
        <FullScreenLoader open={loader ? loader : state.FullScreenLoader} />
      </Container>
      <Popover
        id={"pop-publish-schedule"}
        open={isPublishSchedulePopOpen}
        anchorEl={anchorEl}
        onClose={handleCloseDatePopover}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Stack spacing={2} sx={{ width: "100%" }} alignItems="center">
            {dateComponent === "date" && (
              <>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "100%" }}>
                    <DateCalendar
                      value={dayjs(schedulePublishDate)}
                      onChange={(e: any) => {
                        handleDateChange(e, "date");
                      }}
                    />
                  </div>
                  <MultiSectionDigitalClock
                    value={dayjs(schedulePublishTime)}
                    sx={{ marginTop: 5, borderBottom: "none" }}
                    onChange={(e: any) => handleDateChange(e, "time")}
                  />
                </div>
                <Box
                  sx={{
                    borderTop: 1,
                    width: "100%",
                    height: 1,
                    borderColor: Color.color20,
                  }}
                ></Box>
              </>
            )}

            <div
              style={{
                width: "100%",
                justifyContent: "space-between",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Alert style={{ width: "100%", margin: "10px" }} severity="info">
                On {moment(schedulePublishDate).format("MMM DD, YYYY")}
                {moment(schedulePublishTime).format(" h:mm A")}, the event will
                be published.
              </Alert>
            </div>
            <div
              style={{
                width: "100%",
                justifyContent: "flex-end",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Button
                sx={{
                  marginBottom: 2,
                  marginRight: 2,
                  width: "20%",
                }}
                style={{ backgroundColor: Color.primary }}
                variant="contained"
                onClick={eventSchedulePublicDate}
              >
                Schedule
              </Button>
            </div>
          </Stack>
        </LocalizationProvider>
      </Popover>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
        </MenuItem>

        <MenuItem sx={{ color: "error.main" }}>
          <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}

const Styles = {
  labelTextBox: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  labelTextCheckBox: {
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  submitBtn: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    margin: "10px",
  },
  labelTextBoxMg: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  labelTextBoxMgInput: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: 15,
    marginBottom: 15,
  },
  labelText: {
    width: "80%",
    display: "flex",
    justifyContent: "center",
    marginTop: 15,
  },
  labelTable: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: 15,
  },
  inputTextField: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
  },
};
